var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDonation = function SvgDonation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M15.444 11.556c1.16-1.136 2.334-2.497 2.334-4.278A4.28 4.28 0 0 0 13.5 3c-1.369 0-2.333.389-3.5 1.556C8.833 3.389 7.869 3 6.5 3a4.28 4.28 0 0 0-4.278 4.278c0 1.789 1.167 3.15 2.334 4.278L10 17z"
  })));
};
export default SvgDonation;